import { Step } from 'react-joyride';

export const settingsTourSteps: Step[] = [
  {
    target: '[data-tour="settings-header"]',
    content: (
      <div>
        <h4>Settings & Configuration</h4>
        <p>
          Customize your dashboard experience. Configure widgets, branding, integrations, and
          security settings all from this central location.
        </p>
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true
  },
  {
    target: '[data-tour="settings-tabs"]',
    content: (
      <div>
        <h4>Settings Sections</h4>
        <p>
          Navigate between different configuration areas: Widget Settings, Branding, Call Settings,
          Integrations, and Security.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="widget-settings"]',
    content: (
      <div>
        <h4>Widget Settings</h4>
        <p>
          Customize how your chat widget appears on your website. Configure colors, position,
          welcome messages, and more.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="branding-settings"]',
    content: (
      <div>
        <h4>Branding</h4>
        <p>
          Upload your company logo, set brand colors, and customize the look and feel to match your
          brand identity.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="integrations"]',
    content: (
      <div>
        <h4>Integrations</h4>
        <p>
          Connect with third-party services like CRMs, email platforms, and other tools to
          streamline your workflow.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="security-settings"]',
    content: (
      <div>
        <h4>Security Settings</h4>
        <p>
          Manage two-factor authentication, session timeouts, IP restrictions, and other security
          features to keep your account safe.
        </p>
      </div>
    ),
    placement: 'right'
  }
];
